/* Page Assistance (reprend le comportement de keora.co) : filtre des articles, suggestions, fenetre de l'assistant. */
(() => {
  const root = document.querySelector('.k-assist');
  if (!root) return;
  const input = root.querySelector('[data-k-assist-input]');
  const articles = root.querySelector('#articles');
  const empty = root.querySelector('#artEmpty');
  const panel = root.querySelector('#chatPanel');
  const filter = (q) => {
    const query = (q || '').toLowerCase().trim();
    let shown = 0;
    root.querySelectorAll('#artList .art-card').forEach((card) => {
      const hay = `${card.textContent} ${card.getAttribute('data-k') || ''}`.toLowerCase();
      const ok = !query || hay.includes(query);
      card.style.display = ok ? '' : 'none';
      if (ok) shown += 1;
    });
    if (empty) empty.style.display = shown === 0 && query ? 'block' : 'none';
  };
  const seed = (value) => {
    if (input) input.value = value;
    filter(value);
    if (articles) articles.scrollIntoView({ behavior: 'smooth' });
  };
  const chat = (mode) => {
    if (!panel) return;
    const open = mode === 'open' ? true : mode === 'close' ? false : !panel.classList.contains('open');
    panel.classList.toggle('open', open);
  };
  if (input) input.addEventListener('input', () => filter(input.value));
  const form = root.querySelector('[data-k-assist-search]');
  if (form) form.addEventListener('submit', (event) => { event.preventDefault(); seed(input ? input.value : ''); });
  root.addEventListener('click', (event) => {
    const seedEl = event.target.closest('[data-k-assist-seed]');
    if (seedEl) { event.preventDefault(); seed(seedEl.getAttribute('data-k-assist-seed')); }
    const chatEl = event.target.closest('[data-k-assist-chat]');
    if (chatEl) chat(chatEl.getAttribute('data-k-assist-chat'));
  });
  if (window.location.hash === '#planifier' || document.getElementById('KAssistCall')?.querySelector('.form-ok')) {
    document.getElementById('planifier')?.scrollIntoView();
  }
})();
